export default {
    success: {
        create: 'The trend radar was successfully created.',
        update: 'The trend radar was successfully updated.'
    }
}
